<template>
	<div>
		<div class="page-body">
			<div style="display: flex; justify-content: space-between">
				<div>
					<el-form :inline="true" class="demo-form-inline" label-position="right" label-width="90px"
						:model="searcheForm">
						<el-form-item label="卡号:">
							<el-input placeholder="请输入卡号" clearable width="200px" v-model="searcheForm.monthCardSn">
							</el-input>
						</el-form-item>
						<el-form-item label="姓名:">
							<el-input placeholder="请输入姓名" clearable width="200px" v-model="searcheForm.ownerName">
							</el-input>
						</el-form-item>
						<el-form-item label="手机号:">
							<el-input placeholder="请输入手机号" clearable width="200px" v-model="searcheForm.phoneNum">
							</el-input>
						</el-form-item>
						<el-form-item label="订单号:">
							<el-input placeholder="请输入车牌号" clearable width="200px" v-model="searcheForm.orderNumber">
							</el-input>
						</el-form-item>
<el-form-item label="消费类型：" label-width="300">
							<el-select style="width: 100%" v-model="searcheForm.consumeType" clearable
								placeholder="请选择订单状态">
								<el-option v-for="item in consumeTypeList" :key="item.status" :label="item.label"
									:value="item.status"></el-option>
							</el-select>
						</el-form-item>
						<el-button icon="el-icon-search" type="primary" @click="loadConsumeRecordList">搜索</el-button>
					</el-form>
				</div>
				<!-- 	<div>
					<el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">新增</el-button>
				</div> -->
			</div>
		</div>
		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="users" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column prop="monthCardSn" label="卡号" fixed align="center" width="180">
					<!-- 					<template slot-scope="scope">
						<el-tag v-if="scope.row.cardType == 2 " type="success">
							<h3>充值卡 {{scope.row.monthCardSn}}</h3>
						</el-tag>
						<el-tag v-if="scope.row.cardType == 1 " type="warning">
							包月卡 {{scope.row.monthCardSn}}
						</el-tag>
					</template> -->
				</el-table-column>

				<el-table-column prop="amount" label="余额（元）" fixed align="center" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.amount == null">0</span>
						<span v-if="scope.row.amount != null">{{
              scope.row.amount / 100
            }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="chargeUserName" label="姓名" fixed align="center" width="120"></el-table-column>
				<el-table-column prop="chargeUserPhone" label="手机号" fixed align="center" width="120"></el-table-column>
				<!-- <el-table-column prop="plateNum" label="车牌号" width="150" align="center"></el-table-column> -->
				<el-table-column prop="orderNumber" label="订单号" width="200" align="center"></el-table-column>


				<el-table-column prop="consumeType" label="操作类型" width="200" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.consumeType==0" type="danger">消费</el-tag>
						<el-tag v-if="scope.row.consumeType==1" type="primary">用户充值</el-tag>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="cardType" label="卡片类型" width="200" align="center">
					
				</el-table-column> -->
				<el-table-column prop="beforeAmount" label="消费前金额(分)" width="120" align="center"></el-table-column>
				<el-table-column prop="consumeAmount" label="消费金额(分)" width="120" align="center"></el-table-column>
				<el-table-column prop="actualConsumeAmount" label="实际消费金额(分)" width="120" align="center">
				</el-table-column>

				<el-table-column prop="afterAmount" label="消费后金额(分)" width="120" align="center"></el-table-column>
				<el-table-column prop="consumeStatus" label="交易状态" width="200" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.consumeStatus==0" type="info">预付费</el-tag>
						<el-tag v-if="scope.row.consumeStatus==1" type="warning">预付费交易进行中</el-tag>
						<el-tag v-if="scope.row.consumeStatus==2" type="success">交易完成</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="actualAfterAmount" label="最终金额(分)" width="120" align="center"></el-table-column>
				<!-- <el-table-column prop="expireDate" label="到期日期" width="120" align="center"></el-table-column>
				<el-table-column prop="address" label="联系地址" width="200" align="center"></el-table-column> -->
			</el-table>
			<div style="display: flex; justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px">
			<div>
				<el-form :model="form" :rules="formRules" ref="formRef" label-position="right" label-width="100px">
					<el-form-item label="卡片类型">
						<el-select v-model="form.cardType" style="width: 85%" :disabled="form.disabled">
							<el-option v-for="item in cardTypeOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择站点小区:" prop="stationId">
						<el-select @change="stationChanged" style="width: 85%" v-model="form.stationId"
							placeholder="请选择" filterable>
							<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收费标准" prop="" v-if="visiblePrivacy && form.cardType ==1">
						<span>{{stationPrivacyText}}</span>
					</el-form-item>

					<el-form-item label="卡内余额" prop="" v-if="form.cardType ==2" disabled>
						<span>{{form.amount/100}} 元</span>
					</el-form-item>

					<el-form-item label="卡号:" prop="monthCardSn">
						<el-input type="number" size="mini" placeholder="请输入卡号" style="width: 100%" clearable
							prefix-icon="el-icon-edit" v-model="form.monthCardSn"></el-input>
					</el-form-item>

					<el-form-item label="姓名:" prop="ownerName">
						<el-input size="mini" placeholder="请输入姓名" style="width: 100%" clearable
							prefix-icon="el-icon-edit" v-model="form.ownerName"></el-input>
					</el-form-item>
					<el-form-item label="手机号:" prop="phoneNum">
						<el-input size="mini" placeholder="请输入手机号" style="width: 100%" clearable
							prefix-icon="el-icon-edit" v-model="form.phoneNum"></el-input>
					</el-form-item>
					<el-form-item label="有效期:" prop="">
						{{nowDate}} 至 {{tomorrow}} , 新增卡片有两天有效期，用于开卡刷卡测试。
					</el-form-item>

				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddMonthCard">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="选择门禁" :visible.sync="dialogGrantVisible" width="500px">
			<div>
				<el-form :model="formGrant" :rules="formRules" ref="formRef" label-position="right" label-width="100px">
					<el-form-item label="卡号:" prop="monthCardSn">
						<el-input size="mini" placeholder="请输入卡号" style="width: 100%" clearable
							prefix-icon="el-icon-edit" v-model="formGrant.monthCardSn"></el-input>
					</el-form-item>
					<el-form-item label="选择门禁:" prop="">
						<el-select style="width: 100%" v-model="formGrant.doors" multiple filterable remote
							reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
							<el-option v-for="item in grantOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogGrantVisible = false">取 消</el-button>
				<el-button type="primary" @click="doGrant">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 表格 END -->
		<el-dialog :title="titleRecharge" :visible.sync="dialogRechargeVisible" width="500px">
			<div>
				<el-form :model="formRecharge" :rules="formRules" ref="formRef" label-position="right"
					label-width="100px">
					<el-form-item label="卡号:" prop="monthCardSn">
						<el-input size="mini" placeholder="请输入卡号" style="width: 100%" clearable
							prefix-icon="el-icon-edit" v-model="formRecharge.monthCardSn" readonly></el-input>
					</el-form-item>
					<el-form-item label="收费标准" prop="" v-if="visiblePrivacy2">
						<span>{{stationPrivacyText2}}</span>
					</el-form-item>
					<template v-if="formRecharge.cardType == 1">
						<el-form-item label="续费方式:" prop="feeType">
							<template v-if="formRecharge.feeType == 1">按月续约</template>
							<template v-if="formRecharge.feeType == 2">按季度续约</template>
							<template v-if="formRecharge.feeType == 3">按年续约</template>
						</el-form-item>
						<el-form-item label="续费长度:" prop="value">
							<el-select v-model="formRecharge.value" placeholder="请选择">
								<el-option v-for="item in valueOptions" :key="item.value" :label="item.label"
									:value="item.value" :disabled="item.disabled">
								</el-option>
							</el-select>
						</el-form-item>
					</template>
					<template v-if="formRecharge.cardType == 2">
						<el-form-item label="卡内余额:" prop="value">
							{{formRecharge.amount/100}} 元
						</el-form-item>
						<el-form-item label="充值金额:" prop="value">
							<el-select v-model="formRecharge.value" placeholder="请选择">
								<el-option v-for="item in rechargeValueOptions" :key="item.value" :label="item.label"
									:value="item.value" :disabled="item.disabled">
								</el-option>
							</el-select>
						</el-form-item>
					</template>

					<!--

                       <el-form-item label="生效日期:" prop="amount">
                          <el-date-picker v-model="formRecharge.startTime" type="date" placeholder="选择日期">
                          </el-date-picker>
                      </el-form-item>

                      <el-form-item label="过期日期:" prop="amount">
                          <el-date-picker v-model="formRecharge.expireTime" type="date" placeholder="选择日期">
                          </el-date-picker>
                      </el-form-item>

                     -->

					<el-form-item label="备注:" prop="remark">
						<el-input type="textarea" v-model="formRecharge.remark"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogRechargeVisible = false">取 消</el-button>
				<el-button type="primary" @click="recharge">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		deleteRequest,
		putRequest,
		getRequest,
		postRequest,
	} from "../../utils/api";
	import {
		apiListConsumeList
	} from "../charge/card-consume-list";

	export default {
		name: "ChargeVipCard",
		data() {
			return {
				title: "", //模态窗口 标题
				searcheForm: {}, //搜索
				stationList: [],
				stationIdOptions: [],
				visiblePrivacy: false,
				stationPrivacyText: '',
				visiblePrivacy2: false,
				stationPrivacyText2: '',
				nowDate: null,
				tomorrow: null,
				consumeTypeList:[{status:0,label:'刷卡消费'},{status:1,label:'充值'}],
				cardStatusOptions: [{
						value: 1,
						label: "使用中",
					},
					{
						value: 2,
						label: "已到期",
					},
				],
				cardTypeOptions: [{
						value: 1,
						label: "包月卡",
					},
					{
						value: 2,
						label: "充值卡",
					},
				],
				grantOptions: [],
				users: [], //列表数据
				loading: false,
				dialogVisible: false, // 是否显示 模态窗口
				dialogRechargeVisible: false,
				dialogGrantVisible: false,
				titleRecharge: "月卡充值续费",
				formRecharge: {
					id: null,
					monthCardSn: null,
					feeType: null,
					remark: null,
					value: null,
					amount: 0,
				},
				formGrant: {
					id: null,
					monthCardSn: null,
					doors: null,
				},
				valueOptions: [],
				rechargeValueOptions: [{
					value: 1,
					label: "1元"
				}, {
					value: 10,
					label: "10元"
				}, {
					value: 20,
					label: "20元"
				}, {
					value: 50,
					label: "50元"
				}, {
					value: 100,
					label: "100元"
				}],
				total: 0,
				page: 1,
				size: 10,
				form: {
					disabled: true
				},
				formRules: {
					address: [{
						required: true,
						message: "请输入地址",
						trigger: "blur",
					}, ],
					cardStatus: [{
						required: true,
						message: "请选择卡状态",
						trigger: "blur",
					}, ],
					effectiveDate: [{
						required: true,
						message: "请输入开始时间",
						trigger: "blur",
					}, ],
					expireDate: [{
						required: true,
						message: "请输入结束时间",
						trigger: "blur",
					}, ],
					monthCardSn: [{
						required: true,
						message: "请输入卡号",
						trigger: "blur",
					}, ],
					ownerName: [{
						required: true,
						message: "请输入姓名",
						trigger: "blur",
					}, ],
					phoneNum: [{
						required: true,
						message: "请输入手机号",
						trigger: "blur",
					}, ],
					plateNum: [{
						required: true,
						message: "请输入车牌号",
						trigger: "blur",
					}, ],
				},
			};
		},
		mounted() {
			this.loadConsumeRecordList();
		},
		methods: {
			formatNow() {
				let date = new Date();
				let year = date.getFullYear(); // 年
				let month = date.getMonth() + 1; // 月
				let day = date.getDate(); // 日
				let week = date.getDay(); // 星期
				let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
				let hour = date.getHours(); // 时
				hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
				let minute = date.getMinutes(); // 分
				minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
				let second = date.getSeconds(); // 秒
				second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
				this.nowDate = `${year}/${month}/${day}`;

				this.formatTomorrow();
			},
			formatTomorrow() {
				let now = new Date();
				let date = new Date(now.getTime() + 86400 * 1000);
				let year = date.getFullYear(); // 年
				let month = date.getMonth() + 1; // 月
				let day = date.getDate(); // 日
				let week = date.getDay(); // 星期
				let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
				let hour = date.getHours(); // 时
				hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
				let minute = date.getMinutes(); // 分
				minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
				let second = date.getSeconds(); // 秒
				second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
				this.tomorrow = `${year}/${month}/${day}`;


			},
			async stationChanged(v) {
				let resp = await getRequest('/api/card-privacy/station/' + v, {});
				let data = resp.data;
				this.visiblePrivacy = true;
				this.stationPrivacyText = '';
				this.stationPrivacyText += data.name;
				this.stationPrivacyText += ';收费：' + parseInt(data.price) / 100;
				if (data.feeType == 1) {
					this.stationPrivacyText += '/月';
				} else if (data.feeType == 2) {
					this.stationPrivacyText += '/季度';
				} else if (data.feeType == 3) {
					this.stationPrivacyText += '/年';
				}
				console.log(JSON.stringify(resp));
			},
			async stationChanged2(v) {
				let resp = await getRequest('/api/card-privacy/station/' + v, {});
				let data = resp.data;
				this.visiblePrivacy2 = true;
				this.stationPrivacyText2 = '';
				this.stationPrivacyText2 += data.name;
				this.stationPrivacyText2 += ';收费：' + parseInt(data.price) / 100;
				if (data.feeType == 1) {
					this.stationPrivacyText2 += '/月';
				} else if (data.feeType == 2) {
					this.stationPrivacyText2 += '/季度';
				} else if (data.feeType == 3) {
					this.stationPrivacyText2 += '/年';
				}
				console.log(JSON.stringify(resp));
			},
			doGrant() {
				console.log(JSON.stringify(this.formGrant));
				postRequest("/api/vipCard/bind-door", this.formGrant).then((resp) => {
					if (resp.status == 200) {
						Message.success({
							message: "门禁已绑定，请刷卡测试"
						});
					} else {
						Message.error({
							message: resp.msg
						});
					}
				});
			},
			remoteMethod(query) {
				if (query != "") {
					getRequest("/door/list-dict", {
						keyword: query
					}).then((resp) => {
						if (resp.status == 200) {
							console.log(JSON.stringify(resp.data));
							this.grantOptions = resp.data;
						}
					});
				}
			},
			showGrantDoorOperation(row) {
				//弹出门禁授权
				this.dialogGrantVisible = true;
				this.formGrant = {
					id: null,
					monthCardSn: null,
					doors: [],
				};
				this.formGrant.id = row.id;
				this.formGrant.monthCardSn = row.monthCardSn;

				getRequest("/api/vipCard/list-grant-door/" + row.id).then((resp) => {
					if (resp.status == 200) {
						let bindDoors = resp.data;
						console.log("用户已授权门禁列表=" + JSON.stringify(bindDoors));
						let grantDoors = new Array();
						for (let index in bindDoors) {
							this.grantOptions.push({
								label: bindDoors[index].doorName,
								value: bindDoors[index].doorId,
							});
							grantDoors.push(bindDoors[index].doorId);
						}
						this.formGrant.doors = grantDoors;

						this.$set(this.formGrant, "doors", grantDoors);
					}
				});
			},
			showRecharge(row) {
				console.log("充值哟");
				this.dialogRechargeVisible = true;
				this.formRecharge.id = row.id;
				this.stationChanged(row.stationId);
				this.formRecharge.monthCardSn = row.monthCardSn;
				this.formRecharge.cardType = row.cardType;
				this.formRecharge.amount = row.amount;
				getRequest("/api/vipCard/get-recharge-info/" + row.id).then((resp) => {
					if (resp.status == 200) {
						let data = resp.data;
						console.log(JSON.stringify(data));
						this.formRecharge.feeType = data.feeType;
						if (this.formRecharge.feeType == 1) {
							for (let i = 1; i <= 12; i++) {
								this.valueOptions[i - 1] = {
									label: i + "个月",
									value: i
								};
							}
						}
						if (this.formRecharge.feeType == 2) {
							for (let i = 1; i <= 4; i++) {
								this.valueOptionsp[i - 1] = {
									label: i + "个季度",
									value: i
								};
							}
						}
						if (this.formRecharge.feeType == 3) {
							this.valueOptions[0] = {
								label: "1年",
								value: i
							};
						}
					}
				});
			},
			recharge() {
				let data = this.formRecharge;
				postRequest("/api/vipCard/recharge", data).then((resp) => {
					if (resp.status == 200) {
						Message.success({
							message: "充值成功",
						});
					} else {
						Message.error({
							message: resp.msg,
						});
					}
				});
			},
			formatGender(row, column) {
				return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
			},
			formatEnable(row, colum) {
				return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
			},
			// 添加用户按钮
			showAddEmpView() {
				this.form = {};
				this.title = "新增";
				this.dialogVisible = true;
				this.form.disabled = false;
				this.formatNow();
			},
			//编辑用户按钮
			showEditEmpView(data) {
				this.title = "编辑";
				this.form = data;
				this.nowDate = data.effectiveDate;
				this.tomorrow = data.expireDate;
				this.dialogVisible = true;
				this.form.disabled = true;
			},

			//添加卡 && 更新卡信息
			doAddMonthCard() {
				this.$refs["formRef"].validate((valid) => {
					if (valid) {
						let url = "";
						let res;
						if (this.form.id) {
							url = `/api/vipCard/update`;
							res = putRequest(url, this.form);
						} else {
							url = `/api/vipCard/addCard`;
							res = postRequest(url, this.form);
						}
						res.then((resp) => {
							if (resp) {
								this.dialogVisible = false;
								this.loadConsumeRecordList();
							}
						});
					}
				});
			},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.loadConsumeRecordList();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.loadConsumeRecordList("advanced");
			},
			// 查询桩列表
			loadConsumeRecordList(type) {
				this.loading = true;
				// let url = "/api/vipCard/?page=" + this.page + "&size=" + this.size;
				// postRequest(url, this.searcheForm).then((resp) => {
				// 	this.loading = false;
				// 	if (resp) {
				// 		this.users = resp.data.list;
				// 		this.total = resp.data.total;
				// 	}
				// });
				apiListConsumeList(this.page, this.size, this.searcheForm).then(resp => {
					this.loading = false;
					if (resp) {
						this.users = resp.data.list;
						this.total = resp.data.total;
					}
				})
			},
			initDictionaryStation() {
				apiListStations({
					page: 1,
					size: 9999
				}).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
					}
				});
			},
			showDel(row) {
				let monthCardId = row.id
				this.$confirm(
						"此操作将永久删除记录, 是否继续?",
						"提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning"
						}
					)
					.then(() => {
						deleteRequest(`/api/vipCard/remove/${row.id}`).then(
							(resp) => {
								this.$message({
									type: "info",
									message: "删除完成",
								});
							}
						);
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
		},
	};
</script>

<style>
	.page-body {
		margin-top: 30px;
	}

	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}
</style>
